document.addEventListener('DOMContentLoaded',()=>{const b=document.querySelector('[data-mobile-toggle]');const m=document.querySelector('[data-mobile-menu]');if(b&&m)b.addEventListener('click',()=>m.classList.toggle('is-open'));});

document.addEventListener('DOMContentLoaded', () => {
  const dataEl = document.getElementById('rmTradeData');
  const category = document.getElementById('rmTradeCategory');
  const family = document.getElementById('rmTradeFamily');
  const model = document.getElementById('rmTradeModel');
  const broken = document.getElementById('rmTradeBroken');
  const complete = document.getElementById('rmTradeComplete');
  const result = document.getElementById('rmTradeResult');
  const resultModel = document.getElementById('rmTradeResultModel');
  const resultPrice = document.getElementById('rmTradeResultPrice');
  const resultMessage = document.getElementById('rmTradeCompleteMessage');
  if (!dataEl || !category || !family || !model || !broken || !complete || !result) return;

  let tradeData = {};
  try { tradeData = JSON.parse(dataEl.textContent); } catch (e) { return; }

  const resetDynamic = (select, placeholder) => {
    select.innerHTML = `<option value="">${placeholder}</option>`;
    select.disabled = true;
  };

  const resetFixed = (select) => {
    select.value = '';
    select.disabled = true;
  };

  const estimateIncomplete = (price) => {
    if (!price || /quote/i.test(price)) return 'Individual Quote';
    const match = String(price).match(/\$([\d,.]+)/);
    if (!match) return price;
    const base = parseFloat(match[1].replace(/,/g,''));
    if (!Number.isFinite(base)) return price;
    const estimate = Math.max(1, Math.round((base * 0.50) / 5) * 5);
    return `$${estimate}${String(price).includes('+') ? '+' : ''}`;
  };

  category.addEventListener('change', () => {
    resetDynamic(family, 'Choose a brand or family');
    resetDynamic(model, 'Choose your exact model');
    resetFixed(broken);
    resetFixed(complete);
    result.hidden = true;
    if (!category.value || !tradeData[category.value]) return;
    Object.keys(tradeData[category.value]).forEach(name => {
      const option = document.createElement('option');
      option.value = name;
      option.textContent = name;
      family.appendChild(option);
    });
    family.disabled = false;
  });

  family.addEventListener('change', () => {
    resetDynamic(model, 'Choose your exact model');
    resetFixed(broken);
    resetFixed(complete);
    result.hidden = true;
    if (!category.value || !family.value) return;
    (tradeData[category.value][family.value] || []).forEach(item => {
      const option = document.createElement('option');
      option.value = item.model;
      option.textContent = item.model;
      option.dataset.price = item.price;
      model.appendChild(option);
    });
    model.disabled = false;
  });

  model.addEventListener('change', () => {
    resetFixed(broken);
    resetFixed(complete);
    result.hidden = true;
    if (model.value) broken.disabled = false;
  });

  broken.addEventListener('change', () => {
    resetFixed(complete);
    result.hidden = true;
    if (!broken.value || !model.value) return;

    if (broken.value === 'no') {
      resultModel.textContent = model.value;
      resultPrice.textContent = 'Not Eligible';
      resultMessage.innerHTML = '<strong>This device is not broken.</strong> This Reckless Mods program is specifically for broken, damaged, dead, or otherwise faulty electronics, so we do not purchase working devices through this program.';
      result.hidden = false;
      return;
    }

    complete.disabled = false;
  });

  complete.addEventListener('change', () => {
    if (!complete.value || !model.value || broken.value !== 'yes') {
      if (broken.value !== 'no') result.hidden = true;
      return;
    }

    const selected = model.options[model.selectedIndex];
    const completePrice = selected.dataset.price || 'Quote';
    const displayPrice = complete.value === 'yes' ? completePrice : estimateIncomplete(completePrice);

    resultModel.textContent = model.value;
    resultPrice.textContent = displayPrice;

    if (complete.value === 'yes') {
      resultMessage.innerHTML = `<strong>Broken + complete:</strong> ${displayPrice} is the current estimated starting buyback value for this model. The device may still have repairable faults, but additional damage or multiple issues can lower the final offer after inspection.`;
    } else {
      resultMessage.innerHTML = `<strong>Broken + incomplete:</strong> the current rough estimate is ${displayPrice}. This estimate is based on about 50% of the complete-device starting value because missing parts can change the value significantly. Your final offer may be higher or lower after inspection.`;
    }

    result.hidden = false;
  });
});

/* ===== v29 Cinematic Reckless Mods entry landing ===== */
document.addEventListener('DOMContentLoaded', () => {
  const gate = document.getElementById('RecklessEntryGate');
  const enter = document.getElementById('RecklessEnterSite');
  const roar = document.getElementById('RecklessBeastRoar');
  if (!gate || !enter) return;

  const playRoar = () => {
    if (!roar) return;
    try {
      roar.pause();
      roar.currentTime = 0;
      roar.volume = 0.22;
      const playback = roar.play();
      if (playback && typeof playback.catch === 'function') playback.catch(() => {});
    } catch (e) {}
  };

  let introSeen = false;
  try {
    introSeen = sessionStorage.getItem('recklessIntroSeen') === '1';
  } catch (e) {}

  /* Once the visitor has entered during this browsing session, returning Home
     should go straight to the homepage instead of replaying the entrance. */
  if (introSeen) {
    document.documentElement.classList.add('rm-entry-seen');
    document.body.classList.remove('rm-entry-locked');
    gate.classList.remove('is-visible', 'is-intro', 'is-exiting', 'is-leaving');
    gate.setAttribute('aria-hidden', 'true');
    return;
  }

  document.body.classList.add('rm-entry-locked');

  /* Attempt the beast roar with the opening claw animation. Some browsers block
     audible autoplay until the visitor interacts with the page. */
  window.setTimeout(playRoar, 180);

  enter.addEventListener('click', () => {
    if (gate.classList.contains('is-exiting')) return;

    /* Hide the welcome first, replay the claw/flash sequence, then reveal the site. */
    try {
      sessionStorage.setItem('recklessIntroSeen', '1');
    } catch (e) {}
    document.documentElement.classList.add('rm-entry-seen-after-exit');

    gate.classList.remove('is-intro');
    void gate.offsetWidth;
    gate.classList.add('is-exiting');
    playRoar();
    enter.disabled = true;

    window.setTimeout(() => {
      gate.classList.add('is-leaving');
      document.body.classList.remove('rm-entry-locked');
    }, 900);

    window.setTimeout(() => {
      gate.classList.remove('is-visible', 'is-exiting', 'is-leaving');
      gate.setAttribute('aria-hidden', 'true');
    }, 1580);
  });
});

/* v33 cart quantity controls */
document.addEventListener('click', function (event) {
  var minus = event.target.closest('[data-rm-qty-minus]');
  var plus = event.target.closest('[data-rm-qty-plus]');
  if (!minus && !plus) return;
  var wrapper = event.target.closest('[data-rm-quantity]');
  if (!wrapper) return;
  var input = wrapper.querySelector('.rm-cart-qty-input');
  if (!input) return;
  var current = parseInt(input.value || '0', 10);
  if (plus) input.value = current + 1;
  if (minus) input.value = Math.max(0, current - 1);
  input.dispatchEvent(new Event('change', { bubbles: true }));
});
